// CacheKey 7767d0aa7e444fb0aa71889557d4e55c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { request } from '@services/EvolveApiService'

export default {
  read: options =>
    request('put', '/vue/message_center/chat_messages/read', options),
}
